import React from "react";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import OurGallery from "../components/gallery/Gallery";

function Gallery() {
  return (
    <div>
      <Header/>
      <OurGallery />
      <Footer/>
    </div>
  );
}

export default Gallery;
